import { css } from 'styled-components';
import get from 'lodash/get';

import { getContrastColor } from '@fil-react-utils/common';

export default css`
  ${({ bgColor }: any) =>
    bgColor &&
    css`
      background-color: ${(props: any) => get(props.theme.color.base, `${bgColor}.value`)};
      color: ${(props: any) => getContrastColor(get(props.theme.color.base, `${bgColor}.value`))};
    `}

  ${({ color }: any) =>
    color &&
    css`
      color: ${(props: any) => get(props.theme.color.base, `${color}.value`, color)};
    `}
`;
